module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Chapter-rw",
    attrs: {
      "epub:type": "frontmatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p37"
    }
  }, [_c('i', [_vm._v("Being alone was something I had always excelled at. As a kid, I kept to myself from the time I started school. I noticed how the other kids seemed to crave company, how they sought out a pack of friends to roll through life with. That wasn’t me; I never needed anyone. Or anything. As I grew up, that feeling of everything being better if I didn’t have to share it followed me wherever I went. I got strong, and smart, and completely self-sufficient. That was the way I liked it.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_c('i', [_vm._v("That was the way it had always been.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_c('i', [_vm._v("Then, one day, I met the pin in the grenade that blew my entire world apart.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_c('i', [_vm._v("And she obliterated my desire for a simple, solitary life. She destroyed my existence, as I knew it.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_c('i', [_vm._v("I was slain by her; where years in the army had failed to demolish my lone spirit, she blew it to smithereens. She owns me.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_c('i', [_vm._v("And I will walk through fire to protect her.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1fa8b2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Chapter-01.vue
// module id = 72
// module chunks = 0